import DatabaseMapClientRepository from "@domain/repositories/DatabaseMapClientRepository";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";
import { userRoles } from "@domain/models/User";

type Input = void;

type Output = void;

export class WatchMapClientsUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly userStore: UserStore,
    private readonly databaseMapClientRepository: DatabaseMapClientRepository
  ) {}
  execute() {
    const user = this.userStore.user;

    if (user.role === userRoles.root || user.role === userRoles.admin) {
      this.databaseMapClientRepository.watchMapClientsAdmin();
    }

    if (user.role === userRoles.manager) {
      const mapsIds = user.mapsArray.map((x) => x.value);

      this.databaseMapClientRepository.watchMapClientsManager(mapsIds);
    }

    if (user.role === userRoles.operator) {
      const mapsIds = user.mapsIds.map((x) => x.value);

      this.databaseMapClientRepository.watchMapClientsOperator(user.id, mapsIds);
    }

    return;
  }
}
